var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switching-container"},[_c('div',{staticClass:"switching-content"},[_c('div',{staticClass:"loading-spinner"},[_c('i',{staticClass:"el-icon-loading"})]),_c('div',{staticClass:"loading-text"},[_vm._v("正在切换平台...")])])])
}]

export { render, staticRenderFns }